import { useEffect } from "react";
import { useParams } from "react-router";
import useSWRInfinite from "swr/infinite";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { useState } from "react";

import EmptyState from "../../EmptyState";
import { setLoadNavigation } from "../../../../redux/features/settingSlice";
import DiscussionBox from "../Discussion/DiscussionBox";
import OpinionBox from "../Opinion/OpinionBox";

const TableCardList = ({ about }) => {
  const params = useParams();

  const [emptyStateTrigger, setEmptystateTrigger] = useState(false);
  const dispatch = useDispatch();

  const { data: discussion } = useSWRInfinite((pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.results.length) return null;

    return `${process.env.REACT_APP_API}/content/conversations/${params.tableId}/?page=${
      pageIndex + 1
    }`;
  });
  const { data: opinion } = useSWRInfinite((pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.results.length) return null;

    return `${process.env.REACT_APP_API}/content/opinions/${
      params.tableId
    }/?page=${pageIndex + 1}`;
  });

  useEffect(() => {
    if (opinion && discussion) {
      if (
        opinion[0].results.length === 0 &&
        discussion[0].results.length === 0
      ) {
        setEmptystateTrigger(true);
      } else {
        setEmptystateTrigger(false);
      }
    }
  }, [opinion, discussion, dispatch]);

  useEffect(() => {
    if (emptyStateTrigger) {
      dispatch(setLoadNavigation(false));
    }
  }, [dispatch, emptyStateTrigger]);

  return (
    <Box>
      {emptyStateTrigger ? (
        <EmptyState
          title='There is nothing posted yet '
          dis='You can find a new table!'
          btn1='table'
        />
      ) : (
        <>
          <DiscussionBox />
          <OpinionBox />
        </>
      )}
    </Box>
  );
};
export default TableCardList;
